import { ToastContainer } from 'react-toastify';
import { Route, BrowserRouter, Switch, withRouter } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import '../node_modules/@amigoapp/doca/dist/css/doca.min.css';

import { PatientDocumentProvider } from './contexts/PatientDocument';
import { PatientFormProvider } from './contexts/PatientForm';

import HomePage from './pages/Home';
import PassCodePage from './pages/PassCode';
import DocumentPage from './pages/Document';
import PrivacyPolicyView from './pages/PrivacyPolicy';
import PatientFormView from './pages/PatientForm';
import SignaturePage from './pages/Signature';
import FormSignatureView from './pages/FormSignature';
import FormSignatureSuccessView from './pages/FormSignatureSucess';
import SignatureSuccessPage from './pages/SignatureSuccess';
import ExpiredLinkPage from './pages/ExpiredLink';

const TOAST_OPTIONS = {
	position: 'bottom-center',
	autoClose: 2500,
	hideProgressBar: true,
	newestOnTop: false,
	closeOnClick: true,
	rtl: false,
	pauseOnFocusLoss: true,
	draggable: true,
	pauseOnHover: true
};

const App = () => {
	return <>
		<ToastContainer {...TOAST_OPTIONS} />

		<BrowserRouter>
			<Route exact path="/expired/:code?" component={ExpiredLinkPage} />

			<PatientDocumentProvider>
				<Switch>
					<Route exact path="/" component={PassCodePage} />
					<Route exact path="/terms" component={HomePage} />
					<Route exact path="/document" component={DocumentPage} />
					<Route exact path="/signature" component={SignaturePage} />
					<Route exact path="/signature-success" component={SignatureSuccessPage} />
				</Switch>
			</PatientDocumentProvider>

			<PatientFormProvider>
				<Switch>
					<Route exact path="/privacy-policy/:code" component={PrivacyPolicyView} />
					<Route exact path="/forms/:code" component={PatientFormView} />
					<Route exact path="/forms/signature/:code" component={FormSignatureView} />
					<Route exact path="/forms/signature-success/:code" component={FormSignatureSuccessView} />
				</Switch>
			</PatientFormProvider>
		</BrowserRouter>
	</>;
};

export default withRouter(App);
